import { Tokens } from '../types';

// getTokensFromNewGoogleSignIn() is used to get the Access Token and Refresh Token from a new Google sign in without signing the user out of their current session
// the function takes no parameters
// The function is returns a promise and needs to be called with await
// The function returns a 'Tokens' object containging the access and refresh token if successful or 'null' if unsuccessful
// e.g. const userId = await getTokensFromNewGoogleSignIn();
export async function getTokensFromNewGoogleSignIn(): Promise<Tokens | null> {
  //get client id from environment variables
  const clientIdResponse: Response = await fetch(
    '/api/getEnv/getGoogleClientId'
  );
  const { clientId } = await clientIdResponse.json();

  return new Promise((resolve) => {
    try {
      // Response Type
      const RESPONSE_TYPE = 'code';

      // Page to redirect to with code
      const REDIRECT_URI = `${window.origin}/auth/postEventGoogleTokensCallback`;

      // Scope | what do we want access to
      const SCOPE =
        'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly';

      // Specify that we need a refresh token
      const ACCESS_TYPE = 'offline';

      // Random number for "state" parameter
      const randomState: string = Math.floor(Math.random() * 99999).toString();

      // Promt to force user to pick account
      const PROMT = 'select_account';

      // Create url parameters
      const params = new URLSearchParams({
        client_id: clientId,
        response_type: RESPONSE_TYPE,
        redirect_uri: REDIRECT_URI,
        scope: SCOPE,
        access_type: ACCESS_TYPE,
        state: randomState,
        promt: PROMT,
      });

      // Open new window to microsoft login page
      const url = `https://accounts.google.com/o/oauth2/auth?${params.toString()}`;

      window.open(url, 'Connect Account', 'width=600,height=800');

      // Listen for event containing access tokens
      window.addEventListener('message', (e) => {
        // Check if event came from the window we opened
        if (e.origin !== window.origin) return resolve(null);

        // 'e.data' is either equal to null or a 'Tokens' object, redundant if statement used to explicitly set the type to either 'Tokens' or 'null'
        if (e.data) {
          return resolve(e.data as Tokens);
        } else {
          return resolve(null);
        }
      });
    } catch (error: unknown) {
      // Specify where error came from, return null
      console.error('src/utils/auth0/getUserIDFromNewGoogleSignIn', error);
      return resolve(null);
    }
  });
}
